import { render, staticRenderFns } from "./meetingDetailNew.vue?vue&type=template&id=381deef6&scoped=true"
import script from "./meetingDetailNew.vue?vue&type=script&lang=js"
export * from "./meetingDetailNew.vue?vue&type=script&lang=js"
import style0 from "./meetingDetailNew.vue?vue&type=style&index=0&id=381deef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381deef6",
  null
  
)

export default component.exports